import { render, staticRenderFns } from "./NewsViewController.vue?vue&type=template&id=29222ef6"
import script from "./NewsViewController.vue?vue&type=script&lang=js"
export * from "./NewsViewController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports